var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "address-table"
  }, [_c('BRow', [_c('BCol', {
    attrs: {
      "cols": "12"
    }
  }, [_vm.editing ? _c('div', {
    staticClass: "mb-4"
  }, [_c('font-awesome-icon', {
    staticClass: "text-info d-inline-block mr-2",
    attrs: {
      "icon": "circle-info"
    }
  }), _c('strong', [_vm._v("Let op!")]), _vm._v(" Wijzigingen in de NAW gegevens zorgen niet automatisch voor een update naar achterliggende systemen of klant. ")], 1) : _vm._e(), _c('BTableSimple', {
    attrs: {
      "small": ""
    }
  }, [_c('BTr', [_c('BTh', [_vm._v("Titel")]), _c('BTd', [_vm.editing ? [_c('BFormInput', {
    attrs: {
      "size": "sm"
    },
    model: {
      value: _vm.localAddress.title,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "title", $$v);
      },
      expression: "localAddress.title"
    }
  })] : [_vm._v(" " + _vm._s(_vm.localAddress.title) + " ")]], 2)], 1), _c('BTr', [_c('BTh', [_vm._v("Bedrijfsnaam")]), _c('BTd', [_vm.editing ? [_c('BFormInput', {
    attrs: {
      "size": "sm"
    },
    model: {
      value: _vm.localAddress.company_name,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "company_name", $$v);
      },
      expression: "localAddress.company_name"
    }
  })] : [_vm._v(" " + _vm._s(_vm.localAddress.company_name) + " ")]], 2)], 1), _c('BTr', [_c('BTh', [_vm._v("Naam")]), _c('BTd', [_vm.editing ? [_c('span', {
    staticClass: "address-edit"
  }, [_c('span', {
    staticClass: "name"
  }, [_c('BFormInput', {
    attrs: {
      "size": "sm",
      "placeholder": _vm.$t('omt.gui.location-management.address-first-name')
    },
    model: {
      value: _vm.localAddress.first_name,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "first_name", $$v);
      },
      expression: "localAddress.first_name"
    }
  }), _c('BFormInput', {
    attrs: {
      "size": "sm",
      "placeholder": _vm.$t('omt.gui.location-management.address-last-name-prefix')
    },
    model: {
      value: _vm.localAddress.last_name_prefix,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "last_name_prefix", $$v);
      },
      expression: "localAddress.last_name_prefix"
    }
  }), _c('BFormInput', {
    attrs: {
      "size": "sm",
      "placeholder": _vm.$t('omt.gui.location-management.address-last-name')
    },
    model: {
      value: _vm.localAddress.last_name,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "last_name", $$v);
      },
      expression: "localAddress.last_name"
    }
  })], 1)])] : [_vm._v(" " + _vm._s(_vm.formatDisplayNameForAddress(_vm.localAddress)) + " ")]], 2)], 1), _c('BTr', [_c('BTh', [_vm._v("Adres")]), _c('BTd', [_vm.editing ? [_c('div', {
    staticClass: "address-edit"
  }, [_c('span', {
    staticClass: "street"
  }, [_c('BFormInput', {
    attrs: {
      "size": "sm",
      "placeholder": _vm.$t('omt.gui.location-management.address-street')
    },
    model: {
      value: _vm.localAddress.street,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "street", $$v);
      },
      expression: "localAddress.street"
    }
  })], 1), _c('span', {
    staticClass: "house"
  }, [_c('BFormInput', {
    attrs: {
      "size": "sm",
      "placeholder": _vm.$t('omt.gui.location-management.address-houseno')
    },
    model: {
      value: _vm.localAddress.house_no,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "house_no", $$v);
      },
      expression: "localAddress.house_no"
    }
  }), _c('BFormInput', {
    attrs: {
      "size": "sm",
      "placeholder": _vm.$t('omt.gui.location-management.address-houseno-extra')
    },
    model: {
      value: _vm.localAddress.house_no_extra,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "house_no_extra", $$v);
      },
      expression: "localAddress.house_no_extra"
    }
  })], 1)])] : [_vm._v(" " + _vm._s(_vm.localAddress.street) + " " + _vm._s(_vm.localAddress.house_no) + " " + _vm._s(_vm.localAddress.house_no_extra) + " ")]], 2)], 1), _c('BTr', [_c('BTh', [_vm._v("Postcode + Plaats")]), _c('BTd', [_vm.editing ? [_c('div', {
    staticClass: "address-edit"
  }, [_c('BFormInput', {
    attrs: {
      "size": "sm"
    },
    model: {
      value: _vm.localAddress.zipcode,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "zipcode", $$v);
      },
      expression: "localAddress.zipcode"
    }
  }), _c('BFormInput', {
    attrs: {
      "size": "sm"
    },
    model: {
      value: _vm.localAddress.city,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "city", $$v);
      },
      expression: "localAddress.city"
    }
  })], 1)] : [_vm._v(" " + _vm._s(_vm.localAddress.zipcode) + " " + _vm._s(_vm.localAddress.city) + " ")]], 2)], 1), _c('BTr', [_c('BTh', [_vm._v("Land")]), _c('BTd', [_vm.editing ? [_c('BFormInput', {
    attrs: {
      "size": "sm"
    },
    model: {
      value: _vm.localAddress.country,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "country", $$v);
      },
      expression: "localAddress.country"
    }
  })] : [_vm._v(" " + _vm._s(_vm.localAddress.country) + " ")]], 2)], 1), _c('BTr', [_c('BTh', [_vm._v("Landcode")]), _c('BTd', [_vm.editing ? [_c('BFormInput', {
    attrs: {
      "size": "sm"
    },
    model: {
      value: _vm.localAddress.iso_country_code,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "iso_country_code", $$v);
      },
      expression: "localAddress.iso_country_code"
    }
  })] : [_vm._v(" " + _vm._s(_vm.localAddress.iso_country_code) + " ")]], 2)], 1), _c('BTr', [_c('BTh', [_vm._v("Telefoon")]), _c('BTd', [_vm.editing ? [_c('BFormInput', {
    attrs: {
      "size": "sm"
    },
    model: {
      value: _vm.localAddress.phone_number,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "phone_number", $$v);
      },
      expression: "localAddress.phone_number"
    }
  })] : [_vm._v(" " + _vm._s(_vm.localAddress.phone_number) + " ")]], 2)], 1), _c('BTr', [_c('BTh', [_vm._v("E-mail")]), _c('BTd', [_vm.editing ? [_c('BFormInput', {
    attrs: {
      "size": "sm"
    },
    model: {
      value: _vm.localAddress.email_address,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "email_address", $$v);
      },
      expression: "localAddress.email_address"
    }
  })] : [_vm.isEmailAddressClickable ? _c('a', {
    attrs: {
      "href": _vm.emailHref
    }
  }, [_vm._v(" " + _vm._s(_vm.localAddress.email_address) + " ")]) : _c('span', {
    staticClass: "email-address"
  }, [_vm._v(" " + _vm._s(_vm.localAddress.email_address) + " ")])]], 2)], 1)], 1)], 1)], 1), _vm.editing ? [_c('BRow', [_c('BCol', {
    attrs: {
      "cols": "12"
    }
  }, [!_vm.saving ? _c('OmniButtonCollection', [_c('OmniButton', {
    attrs: {
      "variant": "danger",
      "icon": "times"
    },
    on: {
      "click": _vm.cancelChanges
    }
  }, [_vm._v(" Annuleren ")]), _c('OmniButton', {
    attrs: {
      "disabled": !_vm.canSaveChanges,
      "type": "save",
      "variant": "success",
      "icon": "save"
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v(" Opslaan ")])], 1) : _c('span', [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1), _c('span', {
    staticClass: "label ml-1"
  }, [_vm._v(" Wijzigingen opslaan… ")])])], 1)], 1)] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }